@if (initialized) {
<form [formGroup]="form">
    <div class="row">
        <div class="col-10">
            <rask-input class="col-2"
                aid="avlamningsplats"
                formControlName="avlamningsplats"
                label="{{ texts.avlastningsplats }}"
                [rule]="validation.avlamningsplats"
                [readonly]="isReadOnly"></rask-input>
            <rask-input class="col-3"
                label="{{ texts.namn }}"
                formControlName="namn"
                [rule]="validation.namn"></rask-input>
            <rask-input-number class="col-2"
                aid="koordinatN"
                inputGroup="N"
                formControlName="koordinatN"
                label="{{ texts.koordinater }}"></rask-input-number>
            <rask-input-number class="col-2"
                aid="koordinatE"
                inputGroup="E"
                formControlName="koordinatE"></rask-input-number>
            <rask-checkbox
                aid="viol3"
                class="col-2"
                text="Finns i Viol3"
                formControlName="finnsIViol3"
                [raskDisabledControl]="true"></rask-checkbox>
        </div>
    </div>
</form>
}